import { Cameron } from "@components/icons"
import animation, { cubicBezier } from "@constants/animation"
import colors from "@constants/colors"
import { smallcapsRegular13Styles } from "@constants/typography"
import { navigate } from "gatsby"
import React from "react"
import styled, { css } from "styled-components"

const Container = styled.div<{ displayBanner: boolean }>`
  ${({ displayBanner }) => css`
    display: flex;
    margin-bottom: 52px;
    padding-top: ${displayBanner ? "64px" : "126px"};
    align-items: center;
  `}
`

const PreviousBreadcrumb = styled.button`
  display: flex;
  height: 32px;
  margin: 0;
  padding: 0;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  padding: 0 16px 0 2px;
  transition: background-color ${animation.medium} ${cubicBezier};
  background-color: transparent;
  border: solid 1px ${colors.dividerLineGray};
  border-radius: 2px;
  outline: none;

  &:active {
    outline: none;
  }

  &:focus {
    outline: none;
  }

  &:hover {
    transition:
      background-color ${animation.quick} ${cubicBezier},
      border ${animation.quick} ${cubicBezier};
    background-color: ${colors.dividerLineGray};
    cursor: pointer;
  }
`

const IconWrapper = styled.div`
  width: 24px;
  height: 24px;
  transform: rotate(180deg);
`

const baseTextStyles = `
  ${smallcapsRegular13Styles}
  font-size: 11px;
  color: ${colors.mediumDarkGray};
  line-height: 19px;
  letter-spacing: 1px;
`

const PreviousBreadcrumbText = styled.span`
  ${baseTextStyles}
  display: flex;
  margin-left: 2px;
  padding-top: 3px;
`

const CurrentBreadcrumb = styled.div`
  ${baseTextStyles}
  display: flex;
  height: 32px;
  margin-left: 20px;
  align-items: center;
  color: ${colors.mediumGray};
  opacity: 0.5;
`

const Filler = styled.div`
  width: 100%;
  height: 28px;
`

interface BreadcrumbsProps {
  current?: string
  displayBanner: boolean
  previous?: {
    brand?: {
      name: string
      slug: string
    }
    deviceType?: {
      name: string
      slug: string
    }
    name: string
    slug: string
  }
}

const createBreadcrumbHandler = (slug) => () => {
  navigate(slug)
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  current,
  displayBanner,
  previous,
}) => {
  const previousBreadcrumb = previous
  return (
    <Container displayBanner={displayBanner}>
      {previous && (
        <PreviousBreadcrumb onClick={createBreadcrumbHandler(previous.slug)}>
          <IconWrapper>
            <Cameron strokeColor={colors.mediumDarkGray} />
          </IconWrapper>
          <PreviousBreadcrumbText>{previous.name}</PreviousBreadcrumbText>
        </PreviousBreadcrumb>
      )}
      {current && <CurrentBreadcrumb>{current}</CurrentBreadcrumb>}
      {!previousBreadcrumb && !current && <Filler />}
    </Container>
  )
}

export default Breadcrumbs
